import { Suspense, useState } from 'react';
import * as S from '~/pages/Main/index.styled';
import { FlexStack } from '~/components/atomic';
import { GroupChatCard } from '~/components/atomic/Skeleton';
import { makeIndexArray } from '~/utils';
import GroupChatList from './GroupChatList';

export type GroupChatType = 'all' | 'public' | 'private';
export const GroupChatTypeArray: GroupChatType[] = ['all', 'public', 'private'];

export default function GroupChatSection() {
  const [groupChatType, setGroupChatType] = useState<GroupChatType>('all');

  return (
    <FlexStack>
      <S.GroupChatTypeContainer>
        <S.GroupChatTypeWrapper>
          {GroupChatTypeArray.map((type) => (
            <S.GroupChatTypeButton
              key={type}
              selected={groupChatType === type}
              onClick={() => setGroupChatType(type)}
            >
              {type}
            </S.GroupChatTypeButton>
          ))}
        </S.GroupChatTypeWrapper>
      </S.GroupChatTypeContainer>

      <Suspense
        fallback={
          <FlexStack>
            {makeIndexArray(3).map((el) => (
              <GroupChatCard key={el} />
            ))}
          </FlexStack>
        }
      >
        <GroupChatList groupChatType={groupChatType} />
      </Suspense>
    </FlexStack>
  );
}
